import { render, staticRenderFns } from "./RuleCommon.vue?vue&type=template&id=7fa875c2&scoped=true&"
import script from "./RuleCommon.vue?vue&type=script&lang=js&"
export * from "./RuleCommon.vue?vue&type=script&lang=js&"
import style0 from "./RuleCommon.vue?vue&type=style&index=0&id=7fa875c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa875c2",
  null
  
)

export default component.exports